import { mountVue, unmountVue } from '../vue/mountVue';
import Results from '../vue/Quiz/ProductRecommendations.vue';

export default function loadQuiz() {
  /* ==========================================================================
      Updates template if quiz failed to load
    ========================================================================== */
  jQuery(function ($) {
    // Show the b logo spinner animation for page loads longer than 2 sec
    jQuery(window).on('beforeunload', function () {
      var delay = 2000;
      setTimeout(function () {
        $('.unload-overlay').fadeIn();
      }, delay);
    });

    // if quiz hasn't loaded yet, force the loader to appear on the screen until it has
    if (!window.quizLoaded) {
      jQuery('#PageContainer .unload-overlay').addClass('show');
    }

    // check if quiz is loaded every 500ms (for 9 seconds total)
    // *note: if the quiz successfully loads, the variable window.quizLoaded will be 'true'

    var attempts = 0;
    var DEBUG = window.location.href.indexOf('debug') > 0;

    (function pollForQuizLoaded() {
      setTimeout(function () {
        if (window.quizLoaded) {
          // quiz has successfully loaded, hide the loader
          if (DEBUG) console.error('quiz | quizLoaded TRUE at attempt ' + attempts + '. hiding loader...');
          jQuery('#PageContainer .unload-overlay').removeClass('show');
        } else if (attempts < 18 && !window.quizLoaded) {
          // no quizLoaded yet, but keep looking
          if (DEBUG) console.error('quiz | quizLoaded still false at attempt ' + attempts + '. retrying pollForQuizLoaded...');
          attempts++;
          pollForQuizLoaded();
        } else {
          // the quiz module has not loaded after 9 seconds, so reveal the error message
          if (DEBUG) console.error('quiz | quizLoaded still false after attempt ' + attempts + '. loading error message...');
          // show the error message
          jQuery('.module--quiz').addClass('show error');

          // fix whitespace above error by adding a class to the .main-content wrapper
          jQuery('.main-content').addClass('error');

          // hide the loader
          jQuery('#PageContainer .unload-overlay').removeClass('show');
        }
      }, 500);
    })();
  });

  /* ==========================================================================
      Helper functions
    ========================================================================== */
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor) n = o.constructor.name;
    if (n === 'Map' || n === 'Set') return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) || arr['@@iterator'];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i['return'] != null) _i['return']();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
        }
        _next(undefined);
      });
    };
  }

  function _newArrowCheck(innerThis, boundThis) {
    if (innerThis !== boundThis) {
      throw new TypeError('Cannot instantiate an arrow function');
    }
  }

  /* ==========================================================================
      Libraries - retrieve libraries (jQuery, testing tool utils)
    ========================================================================== */

  /* from jQuery on the page */

  var $jq = window.jQuery;
  /* ==========================================================================
    Test Module
  ========================================================================== */

  var bkl4 = (function ($) {
    /*
      Constants
    ========================================================================== */
    // required: TEST_LABEL, TEST_NAME, VARIATION_LABEL, VARIATION_NAME
    var ROOT_SELECTOR = '.main-content'; // the root element where the quiz should be injected

    var values = [];
    var QUESTION_TREE = [];
    var SELECTED_COLLECTION;
    var data = {};
    /*
      Variation Initialization
      ========================================================================== */

    /**
     * Executes the test. The 'brains' of our operation
     */

    function _init() {
      try {
        data = parseDyVariable(window.quizData, {});
        initQuiz();
      } catch (e) {
        /* eslint-disable-next-line no-console */
        console.error('Error parsing quiz data');
        showErrorMessage();
      }
    }
    /*
      Variation Changes
    ========================================================================== */
    /**
     * get recommended products based on the best match result using vue 3 product cards
     * @param {string} collection
     * @param {object} result
     */
    function setUpPropsData(collection, result) {
      var _this = this;

      var recommendations = data.recommendations.filter(
        function (r) {
          _newArrowCheck(this, _this);

          return r.collection.toLowerCase() === collection.toLowerCase();
        }.bind(this)
      );

      var props = [];

      recommendations.forEach((rec) => {
        if (rec.recommendationType === 'PRODUCT') {
          if (rec.recommendationUrl !== result.resultUrl && rec.published) {
            const lastParam = rec.recommendationUrl.split('/').pop(),
              handle = lastParam.split('?')[0],
              variant = lastParam.includes('variant=') ? lastParam.split('?').pop() : false;
            const obj = {
              handle: handle,
              variant: variant,
            };
            props.push(obj);
          }
        }
      });

      document.querySelector('.js-product-recs').setAttribute('props-data', JSON.stringify(props));
      mountVue('.js-product-recs', Results, this);
    }
    /**
     * get recommended products and collections based on the best match result
     * @param {string} collection
     * @param {object} result
     * @param {object} $results
     * @returns {object} the products[] and collections[] to display
     */

    function getRecommendations(collection, result, $results) {
      var _this = this;

      var recommendations = data.recommendations.filter(
        function (r) {
          _newArrowCheck(this, _this);

          return r.collection.toLowerCase() === collection.toLowerCase();
        }.bind(this)
      );
      var response = {
        products: [],
        collections: [],
      };
      recommendations.reduce(
        function (acc, rec) {
          _newArrowCheck(this, _this);

          if (rec.recommendationType === 'COLLECTION') acc.collections.push(rec);

          if (rec.recommendationType === 'PRODUCT') {
            if (rec.recommendationUrl !== result.resultUrl && rec.published) {
              acc.products.push(rec);
            }
          }

          return acc;
        }.bind(this),
        response
      );
      // getProductRecommendations(response.products, $results);
      // getCollectionRecommendations(response.collections, $results);
      return response;
    }
    /**
     * for each recommended product, fetch data (image, title, price, etc) from the API
     * @param {array} recommendedProducts the array of recommended products for the given result
     * @param {object} $results the results template we're adding to
     */

    function getProductRecommendations(recommendedProducts, $results) {
      var _this2 = this;

      // dispatch the requests and store the promises in a new array
      var requests = recommendedProducts.map(
        function (_ref) {
          var _this3 = this;

          _newArrowCheck(this, _this2);

          var recommendationUrl = _ref.recommendationUrl;
          return $.get(buildJsonUrl(recommendationUrl)).then(
            function (r) {
              _newArrowCheck(this, _this3);
              try {
                return JSON.parse(r.replace(/\n/g, ''));
              } catch (e) {
                return null;
              }
            }.bind(this)
          );
        }.bind(this)
      ); // wait until all promises are resolved before proceeding

      allSettled(requests).then(
        function (responses) {
          var _this4 = this;

          _newArrowCheck(this, _this2);

          // loop over each recommendation response and fill in a recommended product template
          // filter out any responses that aren't objects. if it's not an object, then
          // something went wrong during  the GET request (e.g. an unexpected redirect because the product no longer exists)
          responses
            .filter(
              function (r) {
                _newArrowCheck(this, _this4);

                return r.status === 'fulfilled';
              }.bind(this)
            )
            .map(
              function (r) {
                _newArrowCheck(this, _this4);

                return r.value;
              }.bind(this)
            )
            .sort(sortBestSellers)
            .forEach(
              function (response, recommendedProductIndex) {
                var _this5 = this;

                _newArrowCheck(this, _this4);

                try {
                  var title = response.product_title,
                    handle = response.handle,
                    from_price = response.from_price,
                    description_short = response.description_short,
                    options = response.options,
                    image = response.product_img_url,
                    variant_title = response.variant_title,
                    tags = response.tags,
                    product_id = response.product_id;
                  var $template = $('\n              <li class="grid__item grid__item--sml-spans-4 grid__item--med-spans-6">\n                <a href="#">\n                  <div class="collection-product-recs--image"></div>\n                  <div class="collection-product-recs--details">\n                    <div class="collection-product-recs--details--left">\n                      <h3 class="collection-product-recs--title"></h3>\n                      <span class="collection-product-recs--variant-count"></span>\n                      <div class="yotpo bottomLine" data-product-id></div>\n                    </div>\n                    <div class="collection-product-recs--details--right">\n                      <p class="collection-product-recs--details--price sf-quiz__prod-card-small-price"></p>\n                      <p class="collection-product-recs--details--includes"></p>\n                      <p class="collection-product-recs--variant-count"></p>\n                      <div class="yotpo bottomLine" data-product-id></div>\n                    </div>\n                  </div>\n                </a>\n              </li>\n              ');

                  if (isBestSeller(tags)) $template.addClass('bestseller');

                  if (recommendedProductIndex % 2 === 0) {
                    $template.addClass('grid__item--xlg-start-2');
                  } else {
                    $template.addClass('grid__item--xlg-start-10');
                  } // some recommendations are for a specific product variant

                  var variantId = getParameterByName('variant', recommendedProducts[recommendedProductIndex].recommendationUrl);
                  $('.collection-product-recs--image', $template).css({
                    backgroundImage: 'url('.concat(image, ')'),
                  }); // if there's a variant ID, append it to the URL

                  if (variantId) {
                    handle = ''.concat(handle, '?variant=').concat(variantId);
                  }

                  $('a', $template).attr('href', '/products/'.concat(handle)); // add price, color (from API response) and short description (from data.json) to the template

                  var colorCount = getColorCount(options);

                  if (colorCount) {
                    $template.find('.collection-product-recs--variant-count').text(''.concat(colorCount, ' colors'));
                  } else {
                    $template.find('.collection-product-recs--variant-count').remove();
                  }

                  var reviewId = getReviewId(product_id, tags, handle);
                  $template.find('.yotpo.bottomLine').attr('data-product-id', reviewId).attr('data-product-handle', handle);
                  $template.find('.collection-product-recs--details--price').text(displayPrice(from_price));
                  $template.find('.collection-product-recs--details--includes').text(description_short); // Down Comforters, Down and Down Alternative Pillows display option1 value in the name of the product
                  // when displayed on the site.  Beach Towels display option0.

                  var appendVariantTitle = title.match(/down pillow|down alternative pillow|down comforter|down alternative comforter/i);
                  var appendVariantName = title.match(/beach towel/i);

                  if (appendVariantTitle) {
                    title = ''.concat(variant_title.split(' / ')[1], ' ').concat(title);
                  } else if (appendVariantName) {
                    title = ''.concat(variant_title.split(' / ')[0], ' ').concat(title);
                  }

                  $template.find('.collection-product-recs--title').text(recommendedProducts[recommendedProductIndex].titleOverride || title); // append this recommended product template to the parent results template

                  $('.collection-product-recs--list', $results).append($template);
                  setTimeout(
                    function () {
                      _newArrowCheck(this, _this5);
                    }.bind(this),
                    500
                  );
                } catch (e) {
                  var requestUrl = recommendedProducts[recommendedProductIndex].recommendationUrl;
                  console.error('unable to get JSON from '.concat(requestUrl, '. Skipping.'), e);
                }
              }.bind(this)
            );
        }.bind(this)
      );
    }
    /**
     * for each recommended collection, fetch data (image, title, link, etc) from the API
     * @param {array} collections
     * @param {object} $results
     */

    function getCollectionRecommendations(collections, $results) {
      var _this6 = this;

      // dispatch the requests and store the promises in accessible arrays
      var requests = collections.map(
        function (_ref2) {
          _newArrowCheck(this, _this6);

          var recommendationUrl = _ref2.recommendationUrl;
          return {
            collection: $.getJSON(''.concat(recommendationUrl, '.json')),
            // the collection top-level info (name, handle)
            products: $.getJSON(''.concat(recommendationUrl, '/products.json?limit=1')), // the collection's first product info (for lifestyle image)
          };
        }.bind(this)
      );
      requests.forEach(
        function (requests, recommendationIndex) {
          var _this7 = this;

          _newArrowCheck(this, _this6);

          // once all of the promises resolve, loop through the responses.
          Promise.all(Object.values(requests)).then(
            function (responses) {
              _newArrowCheck(this, _this7);

              var $template = $('\n          <li class="grid__item grid__item--sml-spans-4 grid__item--med-spans-6">\n            <a href="#">\n              <div class="other-collection-recs--list--image">\n              </div>\n              <h3 class="other-collection-recs--list--title"></h3>\n            </a>\n            <div class="other-collection-recs--list--label">\n              <div class="button button--secondary">\n                <a href="#">Shop the collection</a>\n              </div>\n            </div>\n          </li>\n          ');
              responses.forEach(
                /*#__PURE__*/ (function () {
                  var _ref4 = _asyncToGenerator(
                    /*#__PURE__*/ regeneratorRuntime.mark(function _callee(_ref3) {
                      var collection, products, title, handle, response, _JSON$parse, lifestyle_image, backup_image, image;

                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch ((_context.prev = _context.next)) {
                            case 0:
                              (collection = _ref3.collection), (products = _ref3.products);

                              // if it's a collection promise, we get the title and handle to add to our template.
                              if (collection) {
                                (title = collection.title), (handle = collection.handle);
                                $template.find('.other-collection-recs--list--title').text(collections[recommendationIndex].titleOverride || title);
                                $('a', $template).attr('href', collections[recommendationIndex].urlOverride || '/collections/'.concat(handle));
                              }

                              if (!products) {
                                _context.next = 7;
                                break;
                              }

                              _context.next = 5;
                              return $.get(buildJsonUrl('/products/'.concat(products[0].handle)));

                            case 5:
                              response = _context.sent;

                              try {
                                (_JSON$parse = JSON.parse(response.replace(/\n/g, ''))), (lifestyle_image = _JSON$parse.lifestyle_img_url), (backup_image = _JSON$parse.product_img_url);
                                image = lifestyle_image.indexOf('cdn') > -1 ? lifestyle_image : backup_image;
                                $('.other-collection-recs--list--image', $template).css({
                                  backgroundImage: 'url('.concat(image, ')'),
                                });
                              } catch (e) {
                                console.error('error', e);
                              }

                            case 7:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    })
                  );

                  return function (_x) {
                    return _ref4.apply(this, arguments);
                  };
                })()
              ); // append our recommended collection template to the parent results template

              $('.other-collection-recs--list', $results).append($template);
            }.bind(this)
          );
        }.bind(this)
      );
    }
    /**
     * take a question id and build the template including question text and all
     * relevant options for the question.
     * @param {string} questionId
     * @param {boolean} backButton
     */

    function buildQuestion(questionId, backButton) {
      var _this8 = this;

      // push the questionId onto the array. We use this for progress calcuation
      QUESTION_TREE.push(questionId);
      var question = getQuestion(questionId);
      var answers = getAnswers(questionId);
      var template = '\n      <div id="quiz" class="in">\n        <div class="page-width">\n          <div class="grid grid--columns">\n            <div class="grid__item grid__item--sml-spans-4 grid__item--xlg-start-2 quiz-header">\n              <a href="#" class="back">\n                  <img src="https://cdn.shopify.com/s/files/1/0951/7126/files/icon--back-arrow.svg?v=1644943701" alt="back arrow"/>Back\n              </a>\n            </div>\n          </div>\n          <div class="progress">\n            <p class="progress-label">Quiz Progress</p>\n            <div class="progress-bar-outer">\n              <div class="progress-bar-inner"></div>\n            </div>\n          </div>\n          <h1 class="h1 title"></h1>\n          <form class="grid grid--columns">\n            <div class="grid__item grid__item--sml-spans-4  grid__item--med-spans-8 grid__item--med-start-3 grid__item--xlg-start-1 grid__item--xlg-spans-16 options">\n            </div>\n          </form>\n        </div>\n      </div>\n      ';
      var newQuiz = !$('#quiz').length;
      var $template = newQuiz ? $(template) : $('#quiz');

      if (questionId === 'Q1') {
        $template.find('.back').removeClass('show');
      } else {
        $template.find('.back').addClass('show');
      }

      if (questionId !== 'Q1' || backButton) {
        $('#quiz').removeClass('in').addClass('out');
      } // wait for transition to complete before updating title and options

      setTimeout(
        function () {
          var _this9 = this;

          _newArrowCheck(this, _this8);

          // update the question text
          $('.title', $template).html(question.questionText);
          $('.options').empty(); // append each available option to the template

          answers.forEach(
            function (a) {
              _newArrowCheck(this, _this9);

              $('.options').append(
                '\n            <div class="option">\n              <input '
                  .concat(!a.goesTo ? 'disabled' : '', ' class="option"type="radio" name="')
                  .concat(questionId, '" data-collection="')
                  .concat(a.resultingCollection || '', '" data-value="')
                  .concat(a.value || '', '" value="')
                  .concat(a.goesTo, '" id="')
                  .concat(a.answerId, '" />\n              <label for="')
                  .concat(a.answerId, '">\n                <div class="img-wrapper--outer">\n                  ')
                  .concat(a.flag ? '<div class="flag">'.concat(a.flag, '</div>') : '', '\n                  <div class="img-wrapper">\n                    <img src="')
                  .concat(a.answerImage, '" alt="')
                  .concat(a.answerText, '" />\n                  </div>\n                </div>\n                <div class="text-wrapper">\n                  <div class="text">')
                  .concat(a.answerText || '', '</div>\n                  ')
                  .concat(a.answerSubtext && a.showSubtext ? '<div class="subtext">'.concat(a.answerSubtext, '</div>') : '', '\n                </div>\n              </label>\n            </div>\n          ')
              );
              $('#quiz').removeClass('out').addClass('in');
            }.bind(this)
          );
        }.bind(this),
        questionId === 'Q1' && !backButton ? 0 : 800
      ); // update the progress bar

      buildProgress($template); // replace the module quiz with the markup from the current question.

      if (!backButton) {
        if (questionId !== 'Q1') {
          if (window.matchMedia('(max-width: 767px)').matches) {
            $('html, body').animate(
              {
                scrollTop: 0,
              },
              500
            );
          }
        } else {
          $('#main-content .module--quiz').html($template);
          window.scrollTo(0, 0);
        }
      } else {
        if (window.matchMedia('(max-width: 767px)').matches) {
          $('html, body').animate(
            {
              scrollTop: 0,
            },
            500
          );
        }
      }
    }
    /**
     * update the progress bar based on QUESTION_TREE's length
     * @param {object} $template
     */

    function buildProgress($template) {
      var MAX_QUESTION_COUNT = 3;

      if (QUESTION_TREE.indexOf('Q6') > -1 || QUESTION_TREE.indexOf('Q7') > -1) {
        // loungewear has fewer questions than the others
        MAX_QUESTION_COUNT = 4;
      }

      var progressPercent = 0;

      if (QUESTION_TREE.length > 1) {
        progressPercent = (QUESTION_TREE.length / MAX_QUESTION_COUNT) * 100;
      }

      $('.progress .progress-bar-inner', $template).css({
        width: ''.concat(progressPercent, '%'),
      });
    }
    /**
     * build the results page!
     * @param {array} values
     * @param {string} collection
     */

    function buildResults(_x2, _x3) {
      return _buildResults.apply(this, arguments);
    }
    /**
     * bind quiz answer selection events
     * bind reset events
     */

    function _buildResults() {
      _buildResults = _asyncToGenerator(
        /*#__PURE__*/ regeneratorRuntime.mark(function _callee2(values, collection) {
          var _this21 = this;

          var results, $results, result, recommendations, response, _JSON$parse2, title, handle, from_price, description_tag, options, lifestyle_image, backup_image, tags, product_id, variant_title, supportOption, colorCount, image, reviewId;

          return regeneratorRuntime.wrap(
            function _callee2$(_context2) {
              while (1) {
                switch ((_context2.prev = _context2.next)) {
                  case 0:
                    clearInterval(window.checkYotpoStars);
                    results = '\n      <div id="quiz-results">\n        <div class="page-width">\n          <div class="grid grid--columns">\n              <div class="grid__item grid__item--sml-spans-4 grid__item--med-spans-12 grid__item--xlg-spans-14 grid__item--xlg-start-2">\n                <div class="result-header">\n                  <a href="#" class="reset">\n                    <img src="https://cdn.shopify.com/s/files/1/0951/7126/files/icon--back-arrow.svg?v=1644943701" alt="back arrow">Retake Quiz\n                  </a>\n                </div>\n              </div>\n          </div>\n        </div>\n        <div class="page-width">\n          <div class="best-match story story--left module--stacking">\n            <div class="story__media">\n              <picture class="best-match--image" ><img src="" class="story__media-img"></picture>\n            </div>\n            <div class="story__content">\n              <h1 class="h1 title">Your match is:<br/><span class="match"></span></h1>\n              <span class="p5 from-price sf-quiz__prod-card-small-price"></span>\n              <p class="p5 description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent consequat mattis nibh, eget maximus est elementum at. Sed feugiat pulvinar dui, in facilisis sapien mattis scelerisque.</p>\n              <div class="metadata">\n                <span class="color-count"></span>\n                <div class="yotpo bottomLine" data-product-id></div>\n              </div>\n              <div class="actions">\n                <span class="button button--primary">\n                  <a class="url" href="#">\n                    <span>Shop Now</span>\n                  </a>\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n';
                    $results = $(results);
                    result = getResult(values.join(':'));

                    if (result) {
                      _context2.next = 6;
                      break;
                    }

                    return _context2.abrupt('return', console.error("couldn't find a matching result. Show fallback?", values));

                  case 6:
                    _context2.prev = 6;
                    // get product and collection recommendations based on the final collection and best match the user ended up with
                    recommendations = getRecommendations(collection, result, $results);
                    _context2.next = 11;
                    return $.get(buildJsonUrl(result.resultUrl));

                  case 11:
                    response = _context2.sent;
                    (_JSON$parse2 = JSON.parse(response.replace(/\n/g, ''))), (title = _JSON$parse2.product_title), (handle = _JSON$parse2.handle), (from_price = _JSON$parse2.from_price), (description_tag = _JSON$parse2.description_tag), (options = _JSON$parse2.options), (lifestyle_image = _JSON$parse2.lifestyle_img_url), (backup_image = _JSON$parse2.product_img_url), (tags = _JSON$parse2.tags), (product_id = _JSON$parse2.product_id), (variant_title = _JSON$parse2.variant_title);
                    supportOption = options.filter(
                      function (o) {
                        _newArrowCheck(this, _this21);

                        return o.name === 'Support' || o.name === 'Weight';
                      }.bind(this)
                    );

                    if (supportOption.length) {
                      title = ''.concat(variant_title.split(' / ')[1], ' ').concat(title);
                    } // update color, image, price, title, and links for the best match

                    colorCount = getColorCount(options);

                    if (colorCount) {
                      $('.best-match .color-count', $results).text(''.concat(colorCount, ' colors'));
                    } else {
                      $('.best-match .color-count', $results).remove();
                    }

                    image = lifestyle_image.indexOf('cdn') > -1 ? lifestyle_image : backup_image;
                    $('.best-match .best-match--image img', $results).attr({
                      src: image,
                    });
                    $('.best-match .from-price', $results).text(displayPrice(from_price));
                    $('.match', $results).text(result.resultTitle);
                    $('.url', $results).attr({
                      href: result.resultUrl,
                      title: title,
                    }); // get the reviewId and add it to the yotpo container

                    reviewId = getReviewId(product_id, tags, handle);
                    $('.best-match .yotpo.bottomLine', $results).attr('data-product-id', reviewId); // store the product handle - we use this later for rendering reviews

                    $('.best-match .yotpo.bottomLine', $results).attr('data-product-handle', handle); // add descriptions from data.json to the best match template

                    $('.best-match .description', $results).text(description_tag); // add the results to the DOM

                    $('#main-content').removeClass('page-width');
                    $('#main-content .module--quiz').html($results); // now the results are in the DOM, so we renderReviews and yotpo can do its magic.

                    document.title = 'Your match is: '.concat(title, ' | Brooklinen'); // this makes the result bookmarkable/shareable without forcing a page refresh to change the URL

                    window.history.replaceState({}, document.title, '?result='.concat(values.join(':'), '&collection=').concat(collection));
                    window.DY.API('event', {
                      name: 'Completed Quiz',
                      properties: {},
                    });
                    _context2.next = 37;
                    break;

                  case 34:
                    _context2.prev = 34;
                    _context2.t0 = _context2['catch'](6);

                    /* eslint-disable-next-line no-console */
                    console.error('Failed to fetch result details, show fallback?', _context2.t0);

                  case 37:
                    _context2.prev = 37;
                    hideLoader();
                    window.scrollTo(0, 0);
                    setUpPropsData(collection, result, $results);
                    return _context2.finish(37);

                  case 41:
                  case 'end':
                    return _context2.stop();
                }
              }
            },
            _callee2,
            this,
            [[6, 34, 37, 41]]
          );
        })
      );
      return _buildResults.apply(this, arguments);
    }

    function bindEvents() {
      var _this10 = this;

      $(document)
        .on(
          'change',
          '.option input[type=radio]',
          function (e) {
            var _this11 = this;

            _newArrowCheck(this, _this10);

            // whenever a new option is selected, we cache a few values for results processing
            // if the option has a data-value, we use it to calculate the best match
            if (e.currentTarget.dataset.value) {
              values.push(e.currentTarget.dataset.value);
            } // if the option has a collection, we use that to filter the list of recommended collections on the results page

            if (e.currentTarget.dataset.collection) {
              SELECTED_COLLECTION = e.currentTarget.dataset.collection;
            } // if the value prop is RESULTS, then we know to build the results
            // if it's anything else, then we assume it's a question ID and we build
            // the template for the next question in the tree.

            if (e.currentTarget.value === 'RESULTS') {
              $('#quiz .options').animate(
                {
                  opacity: 0,
                },
                200,
                function () {
                  _newArrowCheck(this, _this11);

                  buildResults(values, SELECTED_COLLECTION), 300;
                }.bind(this)
              );
            } else {
              buildQuestion(e.currentTarget.value);
            }
          }.bind(this)
        )
        .on(
          'click',
          '.back',
          function (e) {
            _newArrowCheck(this, _this10);

            e.preventDefault(); // reset our variable cache.

            values.pop();
            QUESTION_TREE.pop();
            buildQuestion(QUESTION_TREE.pop(), true);
          }.bind(this)
        )
        .on(
          'click',
          '.reset',
          function (e) {
            var _this12 = this;

            _newArrowCheck(this, _this10);

            e.preventDefault();
            $('#quiz-results').addClass('out');
            unmountVue('.js-product-recs', this);
            setTimeout(
              function () {
                _newArrowCheck(this, _this12);

                // reset our variable cache.
                values = [];
                QUESTION_TREE = [];
                SELECTED_COLLECTION = null; // reset the page title and URL

                document.title = 'Find the Best Bedding for You | Brooklinen';
                window.history.replaceState({}, document.title, '/pages/gift-finder-quiz');
                buildQuestion('Q1');
              }.bind(this),
              800
            );
          }.bind(this)
        )
        .on(
          'click',
          '.best-match .btn--primary a',
          function (e) {
            _newArrowCheck(this, _this10);

            var handle = e.currentTarget.getAttribute('href');
            localStorage.setItem('quiz-result-click', handle);
          }.bind(this)
        )
        .on(
          'click',
          '.collection-product-recs--list > li > a',
          function (e) {
            _newArrowCheck(this, _this10);

            var handle = e.currentTarget.getAttribute('href');
            localStorage.setItem('quiz-result-click', handle);
          }.bind(this)
        );
    }
    /**
     * build the quiz!
     */

    function initQuiz() {
      var collectionFromUrl = getParameterByName('collection', window.location.href);
      var resultFromUrl = getParameterByName('result', window.location.href); // if there's a collection and a result param in the URL, assume we're
      // loading a bookmarked/refreshed page.

      if (!!collectionFromUrl && !!resultFromUrl) {
        buildResults(resultFromUrl.split(':'), collectionFromUrl);
      } else {
        hideLoader();
        buildQuestion('Q1');
      }

      bindEvents();
      $('.module--quiz').show();
      window.quizLoaded = true;
    }
    /**
     * Adjusts review totals for 'Starter Set' and 'Hardcore Bundle' products
     *  - necessary b/c they all render by default w/ ~25k reviews, the store total
     *  - Starter Set: 6% of total reviews, Hardcore Bundle: 5% of total reviews
     *  - (bl revision, 7/30/18)
     * @param {number} totalReviews
     * @param {string} handle
     */

    function adjustReviewTotals(totalReviews, handle) {
      var _this13 = this;

      if (!handle || !handle.match(/percale|luxe|linen|heathered/)) return;
      totalReviews = parseInt(totalReviews, 10);
      /* Adjust Hardcore Bundle reviews  */
      // hardcore bundles exist for all sheets, so we can reliably grab the total from there

      var hardcoreBundleReviewsContainer = $('.yotpo.bottomLine[data-product-handle*="hardcore-sheet-bundle"] .yotpo-bottomline .yotpo-count'); // an existing page function adds commas to reviews, remove them so we don't miscalculate here [11/20/18 bugfix]
      // only adjust reviews if they haven't been adjusted already

      hardcoreBundleReviewsContainer.each(
        function (i, el) {
          _newArrowCheck(this, _this13);

          var $this = $(el);

          if (!$this.hasClass('quiz-adjusted')) {
            // calculate new number of reviews - hardcore bundle = 5% of total reviews
            var numHardcoreBundleReviews = Math.floor(totalReviews * 0.8); // add commas back to review totals if we've removed them (on-page function)

            numHardcoreBundleReviews = window.Brooklinen.numberWithCommas(numHardcoreBundleReviews); // set new number of reviews on product card

            $this.text(''.concat(numHardcoreBundleReviews, ' Reviews')); // also add class 'comma-added' to prevent page script window.addCommasToReviewCounts from breaking our review totals

            $this.addClass('quiz-adjusted comma-added');
          }
        }.bind(this)
      );
      /* Adjust Starter Set reviews  */

      var starterSetReviewsContainer = $('.yotpo.bottomLine[data-product-handle*="starter-sheet-set"] .yotpo-bottomline .yotpo-count');
      $(starterSetReviewsContainer).each(
        function (i, el) {
          _newArrowCheck(this, _this13);

          var $this = $(el); // only try to adjust starter sets if one actually exists, and they haven't already been adjusted

          if (!$this.hasClass('quiz-adjusted')) {
            // calculate new number of reviews - starter set = 6% of total reviews
            var numStarterSetReviews = Math.floor(totalReviews * 0.06); // add commas back to review totals if we've removed them (on-page function)

            numStarterSetReviews = window.Brooklinen.numberWithCommas(numStarterSetReviews); // set new number of reviews on product card

            $this.text(''.concat(numStarterSetReviews, ' Reviews')); // also add class 'comma-added' to prevent page script window.addCommasToReviewCounts from breaking our review totals

            $this.addClass('quiz-adjusted comma-added');
          }
        }.bind(this)
      );
    }
    /*
    Helper Functions
    ========================================================================== */

    /**
     * The babel config in this repo doesn't support Promise.allSettled
     * so this is a quick little implementation of that without changing the other config at the moment.
     * @param {array} promises
     * @returns {array} the promises with status
     */

    function allSettled(promises) {
      var _this14 = this;

      var wrappedPromises = promises.map(
        function (p) {
          var _this15 = this;

          _newArrowCheck(this, _this14);

          return Promise.resolve(p).then(
            function (val) {
              _newArrowCheck(this, _this15);

              return {
                status: 'fulfilled',
                value: val,
              };
            }.bind(this),
            function (err) {
              _newArrowCheck(this, _this15);

              return {
                status: 'rejected',
                reason: err,
              };
            }.bind(this)
          );
        }.bind(this)
      );
      return Promise.all(wrappedPromises);
    }
    /**
     * get question text based on current question id
     * @param {string} id
     * @returns {object} the question details
     */

    function getQuestion(id) {
      var _this16 = this;

      return (
        data.questions.find(
          function (q) {
            _newArrowCheck(this, _this16);

            return q.questionId === id;
          }.bind(this)
        ) || {}
      );
    }
    /**
     * get available answers on current question id
     * @param {string} questionId
     * @returns {array} the answers for the given question
     */

    function getAnswers(questionId) {
      var _this17 = this;

      return data.answers.filter(
        function (a) {
          _newArrowCheck(this, _this17);

          return a.questionId === questionId && a.published;
        }.bind(this)
      );
    }
    /**
     * get result details based on the collected resultId
     * @param {string} resultId
     * @returns {object} the result details
     */

    function getResult(resultId) {
      var _this18 = this;

      return data.results.find(
        function (r) {
          _newArrowCheck(this, _this18);

          return r.resultId.toLowerCase() === resultId.toLowerCase();
        }.bind(this)
      );
    }
    /**
     * get a URL parameter value
     * @param {string} name
     * @param {string} url
     * @returns {string} the value of the parameter
     */

    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    /**
     * Show the spinning loader
     */

    function showLoader() {
      $('#PageContainer .unload-overlay').addClass('show');
    }
    /**
     * Hides the spinning loader after the app has finished loading
     */

    function hideLoader() {
      $('#PageContainer .unload-overlay').removeClass('show');
    }
    /**
     * get the number of color variants for the product
     * @param {array} options
     * @returns {number} the number of colors variants for the product
     */

    function getColorCount(options) {
      var _this19 = this;

      if (options && options.length) {
        var colorOption = options.filter(
          function (o) {
            _newArrowCheck(this, _this19);

            return o.name === 'Color';
          }.bind(this)
        );

        if (colorOption.length && colorOption[0].values.length > 1) {
          return colorOption[0].values.length;
        }
      }
    }
    /**
     * sort products based on their best seller tag
     * @param {string} a
     * @param {string} b
     * @returns {number} the sort priority
     */

    function sortBestSellers(a, b) {
      if (isBestSeller(a.tags)) return -1;
      if (isBestSeller(b.tags)) return 1;
      return 0;
    }
    /**
     * determine if best seller tag is on product
     * @param {array} tags
     * @returns {boolean} true if best seller
     */

    function isBestSeller(tags) {
      return tags.indexOf('Quiz: Best Sellers') > -1;
    }
    /**
     * some products have a special Review ProductID specified in the tags.
     * search to see if this product has one. If not, use shopify ProductID
     * @param {string} productId
     * @param {array} tags
     * @param {string} handle
     * @returns {string} the proper review ID
     */

    function getReviewId(productId, tags, handle) {
      var _this20 = this;

      // sheet bundles don't have a review id, everything else should have one specified
      if (handle.match(/-hardcore|-move-in-bundle|-starter-sheet-set/)) return;
      var reviewId = productId; // find any tag that starts with Review ProductID:

      var reviewProductId = tags.find(
        function (t) {
          _newArrowCheck(this, _this20);

          return t.indexOf('Review ProductID: ') > -1;
        }.bind(this)
      );

      if (reviewProductId) {
        // get the numerical value of matched the tag
        var _reviewProductId$matc = reviewProductId.match(/\d+/);

        var _reviewProductId$matc2 = _slicedToArray(_reviewProductId$matc, 1);

        reviewId = _reviewProductId$matc2[0];
      }

      return reviewId;
    }
    /**
     * concatenate view=quiz to the end of the product URL
     * @param {string} url
     * @returns {string} the custom view=quiz JSON url
     */

    function buildJsonUrl(url) {
      if (url.indexOf('?') > -1) {
        return ''.concat(url, '&view=quiz');
      }

      return ''.concat(url, '?view=quiz');
    }
    /**
     * Just in case the module is broken (i.e. missing required data), show a user-friendly
     * error message
     */

    function showErrorMessage() {
      // hide app/everything else on the page
      var errorMessageHTML =
        '<div class="module--quiz module--fullbleed" data-color="night-sky-dark">\
          <div class="error-wrapper grid--flex">\
            <div class="error-container">\
              <h2 class="h3">Sorry!</h2>\
              <p class="body p5">It looks like there\'s been an error loading the quiz.</p>\
              <a class="button button--primary" href="http//brooklinen.com">Continue Shopping</a>\
            </div>\
          </div>\
        </div>'; // inject error message template

      $(ROOT_SELECTOR).html(errorMessageHTML); // hide loader if it's showing

      hideLoader();
    }
    /**
     * Display as "From $XX.XX"
     * @param {string} from_price
     * @returns {string} the from display price
     */

    function displayPrice() {
      var from_price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return 'From $'.concat(from_price.replace('.00', ''));
    }
    /**
     * Parses a DY Variable and converts it to Boolean
     * * if the variable is unprocessed (i.e. we're in dev mode, so it's still a dollarsign{} var), return a default
     * @param {string} dyVariableString the DY variable
     * @param {Boolean} defaultValue the DY variable
     * @returns {Boolean} true if the variable has not been changed from a DY variable into a real value
     */

    function parseDyVariable(dyVariableString, defaultValue) {
      var stillUnprocessed = dyVariableString.indexOf('$') === 0 && dyVariableString.indexOf('{') === 1; // still a DY variable, so return the default

      if (stillUnprocessed) return defaultValue; // DY var has been filled, so translate the string value to a proper Boolean
      // (protect from bad user input - must be valid JSON only)

      var value;

      try {
        value = JSON.parse(dyVariableString);
      } catch (err) {
        console.error('dyVariableString value '.concat(dyVariableString, ' is not valid! using default value ').concat(defaultValue));
        value = defaultValue;
      }

      return value;
    }

    return {
      /* Public methods/variables */

      /**
       * Activation function. To be called with `bkl4.activate()` in Activation Trigger
       * @param {Boolean} forceDebug Force DEBUG mode (even without ?sf_debug url param)
       *
       */
      activate: function activate(forceDebug) {
        _init(forceDebug);
      },
      showErrorMessage: showErrorMessage,
      showLoader: showLoader,
      hideLoader: hideLoader,
    };
  })($jq);

  /* ==========================================================================
    Activation Trigger
    ========================================================================== */

  /* using jQuery document.on */
  jQuery(document).on('dy:quiz', function () {
    bkl4.activate();
  });
}
